

































































import { Vue, Component, Prop } from "vue-property-decorator";
import { DocConvenzione } from "../../_models/docConvenzione";
import { DocProgettoOrientamento } from "../../_models/docProgettoOrientamento";
import { bus } from "../../main";
import ConvenzioneTirEstivoSign from "../SignDoc/ConvenzioneTirEstivoSign.vue";
import ProgettoOrientamentoTirEstivoSign from "../SignDoc/ProgettoOrientamentoTirEstivoSign.vue";
import ReportVisitaSign from "../SignDoc/ReportVisitaSign.vue";
import ConvenzioneTirFormativoSign from "../SignDoc/ConvenzioneTirFormativoSign.vue";
import ConvenzioneAlternanzaSign from "../SignDoc/ConvenzioneAlternanzaSign.vue";
import PercorsoFormativoAlternanzaSign from "../SignDoc/PercorsoFormativoAlternanzaSign.vue";
import ConsensoSign from "../SignDoc/ConsensoSign.vue";
import ConvenzioneTirReInsSign from "../SignDoc/ConvenzioneTirReInsSign.vue"
import IspezioneSign from "../SignDoc/IspezioneSign.vue"

@Component({
  components: {
    ConvenzioneTirEstivoSign,
    ProgettoOrientamentoTirEstivoSign,
    ReportVisitaSign,
    ConvenzioneTirFormativoSign,
    ConsensoSign,
    ConvenzioneAlternanzaSign,
    PercorsoFormativoAlternanzaSign,
    ConvenzioneTirReInsSign,
    IspezioneSign
  }
})
export default class DocSignDialog extends Vue {
  @Prop() docInfo!: any;
  @Prop() docType!: string;
  @Prop() activityType!: string;
  @Prop() soggetto!: string;
  @Prop({ required: false, default: '' }) tooltipText!: string;

  //   private docConvenzioneElements: DocConvenzione;
  //   private docProgettoOrientamento: DocProgettoOrientamento;
  private docSignDialog: boolean;

  constructor() {
    super();
    this.docSignDialog = false;
    // this.docConvenzioneElements = {
    //   idConvenzione: 0,
    //   denominazioneIstituto: "",
    //   indirizzoIstituto: "",
    //   capIstituto: "",
    //   comuneIstituto: "",
    //   provinciaIstituto: "",
    //   telefonoIstituto: "",
    //   emailIstituto: "",
    //   codiceFiscaleIstituto: "",
    //   dirigenteIstituto: "",
    //   luogoNascitaDirigenteIstituto: "",
    //   dataNascitaDirigenteIstituto: "",
    //   denominazioneAzienda: "",
    //   indirizzoAzienda: "",
    //   capAzienda: "",
    //   comuneAzienda: "",
    //   provinciaAzienda: "",
    //   telefonoAzienda: "",
    //   emailAzienda: "",
    //   pIvaAzienda: "",
    //   rappresentanteAzienda: "",
    //   luogoNascitaRappresentanteAzienda: "",
    //   dataNascitaRappresentante: "",
    //   dataDocumento: "",
    //   idStatoDoc: 0,
    //   firmaAzienda: "",
    //   firmaIstituto: "",
    //   tipoAttivita: ""
    // };
    // this.docProgettoOrientamento = {
    //   idProgettoOrientamento: 0,
    //   denominazioneIstituto: "",
    //   indirizzoIstituto: "",
    //   capIstituto: "",
    //   comuneIstituto: "",
    //   provinciaIstituto: "",
    //   telefonoIstituto: "",
    //   emailIstituto: "",
    //   codiceFiscaleIstituto: "",
    //   dirigenteIstituto: "",
    //   luogoNascitaDirigenteIstituto: "",
    //   dataNascitaDirigenteIstituto: "",
    //   tutorFormativo: "",
    //   denominazioneAzienda: "",
    //   indirizzoAzienda: "",
    //   capAzienda: "",
    //   comuneAzienda: "",
    //   provinciaAzienda: "",
    //   telefonoAzienda: "",
    //   emailAzienda: "",
    //   pIvaAzienda: "",
    //   indirizzoTirocinio: "",
    //   comuneTirocinio: "",
    //   provinciaTirocinio: "",
    //   codAteco: "",
    //   descrizioneAteco: "",
    //   codIstat: "",
    //   descrizioneIstat: "",
    //   rappresentanteAzienda: "",
    //   luogoNascitaRappresentante: "",
    //   dataNascitaRappresentante: "",
    //   tutorAziendale: "",
    //   tirocinante: "",
    //   dataNascitaTirocinante: "",
    //   luogoNascitaTirocinante: "",
    //   indirizzoTirocinante: "",
    //   comuneTirocinante: "",
    //   provinciaTirocinante: "",
    //   telefonoTirocinante: "",
    //   emailTirocinante: "",
    //   codiceFiscaleTirocinante: "",
    //   classeTirocinante: "",
    //   durataTirocinio: "",
    //   dataInizioPeriodo: "",
    //   dataFinePeriodo: "",
    //   orarioInizioMattino: "",
    //   orarioFineMattino: "",
    //   orarioInizioPomeriggio: "",
    //   orarioFinePomeriggio: "",
    //   usoFuoriSede: "",
    //   posizioneINAIL: "",
    //   numeroPolizzaAssicurativa: "",
    //   assicurazione: "",
    //   facilitazione: "",
    //   attivitaTirocinio: "",
    //   dataDocumento: "",
    //   idStatoDoc: 0,
    //   firmaAzienda: "",
    //   firmaTirocinante: "",
    //   firmaEsercentePatriaPotesta: "",
    //   firmaIstituto: "",
    //   capTirocinio: "",
    //   tipoAttivita: ""
    // };
  }

  created() {
    //@ts-ignore
    // bus.$on("openDocConvenzioneSign", payload => {
    //   this.docConvenzioneElements = payload;
    //   this.docSignDialog = true;
    // });

    // //@ts-ignore
    // bus.$on("openDocProgettoOrientamentoSign", payload => {
    //   this.docProgettoOrientamento = payload;
    //   this.docSignDialog = true;
    // });

    bus.$on("closeDocSignDialog", () => {
      // bus.$emit("closeConvenzione")
      this.docSignDialog = false;
    });
  }
}
